import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { sizeTablet } from '~/styles';

// ygi-learn-article
export const LearnArticleMain = styled.section`
  background-color: #fff;
  padding-bottom: 40px;
  position: relative;

  .icon-heart,
  .icon-heart-filled {
    height: 20px;
    width: 20px;
  }

  ${sizeTablet(css`
    .ygi-author-bio {
      margin: 20px 0;
    }

    .ygi-divider {
      display: none;

      &__bio {
        display: inherit;
      }
    }

    .ygi-show-comments__wrapper {
      padding: 0;
    }
  `)};
`;

// ygi-learn-article__content
export const LearnArticleContent = styled.div`
  position: relative;
`;
